import { jsxs as c, jsx as e } from "react/jsx-runtime";
import p, { useContext as T } from "react";
import { useWindowDimensions as A } from "./useWindowDimensions.js";
import { Disclosures as _ } from "./disclosure.js";
import { T as P, a as n } from "./tableContainer-cf101627.mjs";
import { M as x, a as B } from "./marketingComparisonTableMobileView-a94f5b2a.mjs";
import { u as l } from "./uniqueId-321287e8.mjs";
import { Button as h } from "./button.js";
import { TableContext as k } from "./table.js";
import { B as w } from "./themes-5f0b3c3d.mjs";
import "./index-6a632112.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./types-b577bf77.mjs";
import "./subtract-848336fd.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./textStyles-42cab346.mjs";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./selectInput.js";
import "./cancelCloseFilled-b2127cb6.mjs";
import "./caretDown-8ff83493.mjs";
import "./caretUp-e6db3a6f.mjs";
import "./index-39f84169.mjs";
import "./radio.js";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
import "./textInput.js";
import "./tags.js";
import "./screenReaderOnly.js";
import "./index-98c703e1.mjs";
import "./_commonjsHelpers-d4512b9c.mjs";
const gt = ({
  headerValues: o,
  rowValues: u = [],
  disclosures: r
}) => {
  const { width: a } = A(), { setIsStickyColumnEnabled: b } = T(k), [f, C] = p.useState([]), [s, d] = p.useState(!1);
  return p.useEffect(() => {
    C(u);
  }, [u]), p.useEffect(() => {
    d(
      !!o.find((t) => t.columnButton)
    );
  }, [o]), p.useEffect(() => {
    b(!1);
  }, []), /* @__PURE__ */ c(P, { children: [
    a >= w.tabletMin ? /* @__PURE__ */ c(
      n,
      {
        style: { border: "unset", overflow: "unset" },
        isMarketingTable: !0,
        children: [
          /* @__PURE__ */ e(n.Head, { marketingTable: !0, children: o.map((t) => /* @__PURE__ */ e(
            n.Header,
            {
              marketingTable: !0,
              children: /* @__PURE__ */ c(
                n.CellContent,
                {
                  contentAlignment: t.contentAlignment || "center",
                  flexDirection: "column",
                  children: [
                    t.leadingComponents,
                    t.textValue && /* @__PURE__ */ e(
                      n.CellContentText,
                      {
                        contentAlignment: t.contentAlignment || "center",
                        marketingTable: !0,
                        marketingTableTitleSize: t.textSize || "small",
                        children: t.textValue
                      }
                    ),
                    t.description && /* @__PURE__ */ e(n.CellDescription, { children: t.description })
                  ]
                }
              )
            },
            `${t.id}_${l("table_head")}`
          )) }),
          /* @__PURE__ */ c(
            n.Body,
            {
              marketingTable: !0,
              isColumnButtonEnabled: s,
              children: [
                f.map((t) => /* @__PURE__ */ e(
                  n.Row,
                  {
                    id: t.rowId,
                    children: t.cellData.map((i, m) => /* @__PURE__ */ e(
                      n.Cell,
                      {
                        contentAlignment: o[m].contentAlignment || "center",
                        id: i.id,
                        children: /* @__PURE__ */ e(
                          n.CellContent,
                          {
                            contentAlignment: o[m].contentAlignment || "center",
                            children: /* @__PURE__ */ e(
                              x,
                              {
                                type: i.valueProp.type,
                                textValue: i.valueProp.textValue,
                                informationPopuptipProp: i.valueProp.informationPopuptipProp,
                                informationTooltipProp: i.valueProp.informationTooltipProp,
                                contentAlignment: o[m].contentAlignment || "center"
                              }
                            )
                          }
                        )
                      },
                      `${i.id}_${l("table_cell")}`
                    ))
                  },
                  `${t.rowId}_${l("table_row")}`
                )),
                s && /* @__PURE__ */ e(n.Row, { id: l("table_row_button"), children: o.map((t) => {
                  const {
                    isColumnButtonEnabled: i = !1,
                    buttonText: m = "",
                    ...g
                  } = t.columnButton || {};
                  return /* @__PURE__ */ e(
                    n.Cell,
                    {
                      id: `${t.id}_${l("table_cell")}`,
                      contentAlignment: t.contentAlignment,
                      children: /* @__PURE__ */ e(
                        n.CellContent,
                        {
                          contentAlignment: t.contentAlignment,
                          children: i && /* @__PURE__ */ e(h, { ...g, children: m })
                        }
                      )
                    },
                    `${t.id}_${l("table_cell")}`
                  );
                }) })
              ]
            }
          )
        ]
      }
    ) : /* @__PURE__ */ e(
      B,
      {
        headerValues: o,
        rowValues: u,
        isColumnButtonEnabled: s
      }
    ),
    r && /* @__PURE__ */ e(
      _,
      {
        disclosureContent: r?.disclosureContent,
        id: r?.id,
        className: r?.className,
        disclosureTitleColor: r?.disclosureTitleColor,
        style: r?.style
      }
    )
  ] });
};
export {
  gt as MarketingComparisonTable
};
